import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { DataForDisplayingMenuItemsService } from '../services/data-for-displaying-menu-items.service';
import { ProjectManagerService } from '../services/project-manager.service';
import { DockModeService } from '../services/dock-mode.service';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';

@Component({
  selector: 'app-edit-railing-type',
  templateUrl: './edit-railing-type.component.html',
  styleUrls: ['./edit-railing-type.component.scss']
})
export class EditRailingTypeComponent implements OnInit {
  projectType: string;
  railingType: string;
  selectedType = {
    designRail: false,
    wood: false,
    composite: false,
    steelFlat: false,
    steelRound: false,
    dockRail: false,
    modern: false
  };

  @Output() step2Editer = new EventEmitter();

  goBack(value) {
    this.step2Editer.emit({ name: value });
  }

  constructor(
    public dataForMenu: DataForDisplayingMenuItemsService,
    public projectSrvc: ProjectManagerService,
    public dockMode: DockModeService
  ) {
    this.dataForMenu.railingType.subscribe(type => {
      this.setSelectedSettings(type);
    });
  }

  setRailingType(railingType: string) {
    this.railingType = railingType;
    this.projectType = this.projectSrvc.getProjectType();

    if (this.projectType === 'home' || railingType === 'DockRail') {
      this.dataForMenu.setRailingHeight('36', true);
    } else {
      this.dataForMenu.setRailingHeight('42', true);
      this.dataForMenu.setStairHandrail('', true);
    }
    this.dataForMenu.setRailingType(railingType, true);
    switch (this.railingType) {
      case 'DockRail': {
        // DockRail Series 200: 36" fascia-mounted, single cable infill,
        // no corners, no stairs (see spec)
        this.dataForMenu.setTopRail('200s', true);
        this.dataForMenu.setInfill('horizontalCable', true);
        this.dataForMenu.setPostMounting('Fascia Mount', true);
        this.dataForMenu.setCornerPosts('Single', true);
        this.dataForMenu.setStairHandrail('', true);
        break;
      }
      case 'DesignRail': {
        this.dataForMenu.setTopRail('200s', true);
        this.dataForMenu.setInfill('horizontalCableBaserail', true);
        this.dataForMenu.setPostMounting('Base Mount', true);
        this.dataForMenu.setCornerPosts('Double', true);
        this.dataForMenu.setVerticalPicket('Square', 'Black');
        // also need to send color
        break;
      }
      case 'Modern': {
        // Modern kit (spec p.2): Series 250 top rail only, base mount only,
        // single corner post, 'modern' slat infill (horizontalCable pipeline).
        // Stairs are railed with the same 250 profile; only the ADD-ON stair
        // handrail is off ("Only 1 top rail"). Section span sub-menu lives in
        // Edit Railing Height.
        this.dataForMenu.setTopRail('250s', true);
        this.dataForMenu.setInfill('horizontalCable', true);
        this.dataForMenu.setPostMounting('Base Mount', true);
        this.dataForMenu.setCornerPosts('Single', true);
        this.dataForMenu.setStairHandrail('', true);
        this.dataForMenu.setVerticalPicket('Square', 'Black');
        break;
      }
      case 'Wood': {
        this.dataForMenu.setTopRail('Wood 2x4', true);
        // this.dataForMenu.setStairHandrail('top150', true);
        this.dataForMenu.setInfill('horizontalCableBaserail', true);
        this.dataForMenu.setPostMounting('Fascia Mount', true);
        this.dataForMenu.setCornerPosts('Double', true);
        this.dataForMenu.setVerticalPicket('Tubular', 'Stainless');
        // also need to send color
        break;
      }
      case 'Composite': {
        this.dataForMenu.setTopRail('CompositeTop', true);
        // this.dataForMenu.setStairHandrail('top150', true);
        this.dataForMenu.setInfill('horizontalCableBaserail', true);
        this.dataForMenu.setPostMounting('Core Mount', true);
        this.dataForMenu.setCornerPosts('Single', true);
        this.dataForMenu.setVerticalPicket('Square', 'Black');
        // also need to send color
        break;
      }
      case 'Steel flat bar': {
        this.dataForMenu.setTopRail('Steel Flatbar', true);
        // this.dataForMenu.setStairHandrail('top150', true);
        this.dataForMenu.setInfill('horizontalCableBaserail', true);
        this.dataForMenu.setPostMounting('Fascia Mount', true);
        this.dataForMenu.setCornerPosts('Double', true);
        // also need to send color
        break;
      }
      case 'Steel round tubular': {
        this.dataForMenu.setTopRail('Steel Tubular', true);
        // this.dataForMenu.setStairHandrail('top150', true);
        this.dataForMenu.setInfill('horizontalCableBaserail', true);
        this.dataForMenu.setPostMounting('Fascia Mount', true);
        this.dataForMenu.setCornerPosts('Double', true);
        // also need to send color
        break;
      }
    }
    this.dataForMenu.setRailingType(railingType);
  }

  ngOnInit() {
    this.projectSrvc.projectNewChanges.subscribe(projType => {
      if (projType === 'home') {
        this.dataForMenu.setRailingHeight('36', true);
      } else if (projType !== DockModeService.PROJECT_TYPE) {
        // dock height is fixed at 36" by the DockRail defaults — the
        // business-project 42" rule must not override it
        this.dataForMenu.setRailingHeight('42', true);
        //this.dataForMenu.setStairHandrail('appliedHandrail');
      }
    });
    this.dataForMenu.getCurrentParams();
  }

  clearSelection() {
    this.selectedType = {
      designRail: false,
      wood: false,
      composite: false,
      steelFlat: false,
      steelRound: false,
      dockRail: false,
      modern: false
    };
  }

  setSelectedSettings(value) {
    switch (value) {
      case 'DesignRail': {
        this.clearSelection();
        this.selectedType.designRail = true;
        break;
      }
      case 'Wood': {
        this.clearSelection();
        this.selectedType.wood = true;
        break;
      }
      case 'Composite': {
        this.clearSelection();
        this.selectedType.composite = true;
        break;
      }
      case 'Steel flat bar': {
        this.clearSelection();
        this.selectedType.steelFlat = true;
        break;
      }
      case 'Steel round tubular': {
        this.clearSelection();
        this.selectedType.steelRound = true;
        break;
      }
      case 'DockRail': {
        this.clearSelection();
        this.selectedType.dockRail = true;
        break;
      }
      case 'Modern': {
        this.clearSelection();
        this.selectedType.modern = true;
        break;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/edit-railing-type/edit-railing-type.component.ts